import { axiosInstance } from '../request';
export const getMessageRecordsById = async (messageId) => {
    const response = await axiosInstance.get(`/api/v1/prompt-records/messages/${messageId}?include_raw=false`);
    return response.data;
};
//# sourceMappingURL=promptRecords.api.js.map